var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconControlPanelDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #333;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.91,171.61c-.48-.65-11.92-16.07-31.06-31.66-25.62-20.87-52.87-31.9-78.89-31.9s-53.19,11.03-78.81,31.9c-19.14,15.59-30.58,31.02-31.06,31.66-.71,.96-1.09,2.12-1.09,3.31v.15c0,1.19,.38,2.35,1.09,3.31,.48,.65,11.92,16.07,31.06,31.66,25.62,20.87,52.87,31.9,78.89,31.9s53.19-11.03,78.81-31.9c19.14-15.59,30.58-31.02,31.06-31.66,.71-.96,1.09-2.12,1.09-3.31v-.15c0-1.19-.38-2.35-1.09-3.31Zm-109.95,59.16c-48.84,0-88.11-43.41-98.3-55.77,10.19-12.36,49.46-55.77,98.37-55.77s88.11,43.42,98.3,55.77c-10.19,12.36-49.46,55.77-98.37,55.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175,139.66c-19.49,0-35.34,15.86-35.34,35.34s15.86,35.34,35.34,35.34,35.34-15.86,35.34-35.34-15.86-35.34-35.34-35.34Zm0,58.91c-12.99,0-23.56-10.57-23.56-23.56s10.57-23.56,23.56-23.56,23.56,10.57,23.56,23.56-10.57,23.56-23.56,23.56Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconControlPanelDetail);
export default __webpack_public_path__ + "static/media/icon-control-panel-detail.1b3a6044.svg";
export { ForwardRef as ReactComponent };